import { createFileRoute, Outlet } from '@tanstack/react-router'
import { pageTitle } from '@/lib/page-title'

export const Route = createFileRoute(
	'/(private)/bando/$residenceId/graduatoria'
)({
	head: ({ match }) => ({
		meta: [
			{
				title: pageTitle(
					match.context.appLanguage,
					'admin-ranking:page_title'
				)
			}
		]
	}),
	staticData: {
		breadcrumb: 'admin-ranking:page_title'
	},
	component: () => <Outlet />
})
